module.exports = __webpack_public_path__ + "appstore-icon.png?f774f6e1f8bbaec7f8d9c5a3329b53fc";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/appstore-icon.png
// module id = 311
// module chunks = 0